import $ from "jquery";

import "@babel/polyfill";

import globals from "./js/globalvars"; 

import { scrollbar_width } from './js/scrollbar_width_control';

globals.scrollbar_width = scrollbar_width();

import './js/header';

import './js/waypoint';
import { waypoints } from './js/waypoint_control';

import './js/matchheight';

function start_bx_slider(){
    return import(/* webpackChunkName: "bxslider" */ "./js/jquery.bxslider.min").then(res => {
        console.log('BX script loaded');

        import(/* webpackChunkName: "bx_control" */ "./js/bx_control").then(res => {
            console.log('BX Control Init');
     
            res.meta_slider();
            console.log('BX done');
        }); 
    }); 
}

function start_fancybox(){
    return import(/* webpackChunkName: "fancybox" */ "./js/jquery.fancybox.pack").then(res => {
        console.log('FancyBox script loaded');
    }); 
}

function start_maps(){

    var gmap = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAtQPJP1h8GlSwMgE4xorWHpBRu9_xsWAs";
    
    $.getScript(gmap, () => {
        console.log("Gmap - loaded");
        
        return import(/* webpackChunkName: "map_control" */ "./js/map_control").then(res => {
            console.log('Maps script loaded');
        }); 
    });
}

function img_inspector_start_old(){
    return import(/* webpackChunkName: "panzoom" */ "./js/panzoom").then(res => {
        console.log('Inspector script loaded');

        import(/* webpackChunkName: "img_inspector_control" */ "./js/img_inspector_control").then(res => {
            console.log('Inspector Control init');
        }); 
    }); 
}

function img_inspector_start(){
    return  import(/* webpackChunkName: "img_inspector_control" */ "./js/img_inspector_control").then(res => {
        console.log('Inspector Control init');
    }); 
}

$('.show_extra').on('click', function(event){
	event.preventDefault();
	var item = $(this);
	
	if(item.hasClass('solo') && !item.closest('.extra_toggle').hasClass('active')){
		var parent = item.closest('.solo_block');
		var hidden_content = parent.find('.extra_toggle.active .hidden_extra');
		hidden_content.slideToggle(options);
		parent.find('.extra_toggle.active').removeClass('active');
	}
	
	
	var parent = item.closest('.extra_toggle');
	var hidden_content = parent.find('.hidden_extra');
	
	var options = {
		'start' : function(){
			parent.toggleClass('active');
		},
	}
	
	hidden_content.slideToggle(options);
	 
}); 
 
console.log('Ready');

$(window).on('load', function(){

    console.log('Page Load ready');

    waypoints($('.anim'));
    // meta_slider();

    // sliders
    if($('.post_slider_slides').length > 0){
        start_bx_slider();
    }

    if($('.content_and_slider .gallery .gallery_item').length > 0 ){
        start_fancybox();
    }

    if($('.acf-map').length > 0){
        start_maps();
    }

    if($('.image_inspector').length > 0){
        img_inspector_start();
    }

}); 